import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getTestLabels } from '../../../../utils/getTestLabels.js';
import { LoaderGifBase } from '../../base/LoaderGifBase/LoaderGifBase.js';

const { componentTestLabel } = getTestLabels('LoaderGifBitiba');
/**
 * @deprecated use LoaderSvg instead
 *
 * @param {boolean} fullPage - (optional) Set to `true` to overlay the entire page.
 */
const LoaderGifBitiba = forwardRef((props, ref) => (jsx(LoaderGifBase, { "data-zta": componentTestLabel, theme: "bitiba", ref: ref, ...props })));
LoaderGifBitiba.displayName = 'LoaderGifBitiba';

export { LoaderGifBitiba };
//# sourceMappingURL=LoaderGifBitiba.js.map
